import { httpRequest } from "@/lib/axios";
import type { FormCapability, OwnerFormPayload } from "@/components/cowork/copilot-form-payload";

export type FormRequest = { request_key: string; payload: OwnerFormPayload };
export type FormReceipt = {
  data: { id: string };
  effect: { effect_id: string; hitl_item_id: string; policy_decision_id: string; state: "applied"; replayed: boolean };
};

export async function submitCopilotForm(capability: FormCapability, body: FormRequest): Promise<FormReceipt> {
  const { data } = await httpRequest.post<FormReceipt>(`/copilot/forms/${capability}`, body);
  if (!data?.data?.id || data.effect?.state !== "applied" || !data.effect.effect_id
    || !data.effect.hitl_item_id || !data.effect.policy_decision_id) throw new Error("Unconfirmed form receipt");
  return data;
}
